import { 
    
    LINK_LOADED,
    LINK_CREATED,
    LINK_DELETED,
    LINK_PROCESS_LOADING,
    LINK_PROCESS_FAILED,

} from '../actions/publicLink';
  

const initialState = {
    isLoading: false,
    link: null,
    errors: null,
    isSuccess: false,
    // new: {
    //     isLoading: false,
    //     isSuccess: false,
    //     errors: null
    // }
}

const publicLinkReducer = (state = initialState, action) => {
    switch (action.type) {
        case LINK_LOADED:
            return {
                ...state,
                isLoading: false,
                link: action.payload.link,
                errors: null
            }
        case LINK_CREATED:
            return {
                ...state,
                // new: {
                    isLoading: false,
                    isSuccess: true,
                    errors: null
                // }
            }
        case LINK_DELETED:
            return {
                link: [],
                // new: {
                    isLoading: false,
                    isSuccess: true,
                    errors: null
                // }
            }
        case LINK_PROCESS_LOADING:
            return {
                ...state,
                // new: {
                    isLoading: true,
                    isSuccess: false,
                    errors: null
                // }
            }
        case LINK_PROCESS_FAILED:
            return {
                ...state,
                // new: {
                    isLoading: false,
                    isSuccess: false,
                    errors: action.errors
                // }
            }
        default:
            return state;
    }
};
  
export default publicLinkReducer;
  